import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'

import '~styles/index.scss'
// import { theme } from '~styles/theme.js'
import { isHomePage, clickBackFunction } from '@/utils/index.js'

import './assets/icons'
import '@/components'
import Library from './lib'
Vue.config.productionTip = false

Vue.use(Library)
Vue.config.devtools = process.env.VUE_APP_LOCAL !== '86'
setTimeout(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}, 0)

window.onload = function () {
  getRem(375, 100)
  // theme()
  isHomePage()
  clickBackFunction()
}
window.onresize = function () {
  getRem(375, 100)
}
function getRem (pwidth, prem) {
  var html = document.getElementsByTagName('html')[0]
  var oWidth =
    document.body.clientWidth || document.documentElement.clientWidth
  html.style.fontSize = (oWidth / pwidth) * prem + 'px'
}
getRem(375, 100)
router.beforeEach((to, from, next) => {
  const type = to.meta.type
  // �жϸ�·���Ƿ���Ҫ��¼Ȩ��
  if (type === 'login') {
    console.log(window.sessionStorage.getItem('login'), '�л�·�ɴ���')
    if (window.sessionStorage.getItem('login') === '0' || window.sessionStorage.getItem('login') === null) {
      location.href = '/visitor/login'
    } else {
      next()
    }
  } else {
    next() // ȷ��һ��Ҫ��next()������
  }
})
